import { render, staticRenderFns } from "./ReportsView.vue?vue&type=template&id=312cc8f1&"
import script from "./ReportsView.vue?vue&type=script&lang=js&"
export * from "./ReportsView.vue?vue&type=script&lang=js&"
import style0 from "./ReportsView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReportsView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports